module.exports = __webpack_public_path__ + "img/kitchenScreen.17690b43.png";